<template>
	<div class="page-content">
		<div class="content-wrapper">
			<ja-dashboard-container :title="$t('simulationManagement')">
				<content>
					<div class="grid sort-header">
						<div class="grid-row">
							<ja-dropdown
								v-model="simulationTypeFilteringOptionIndex"
								:label="$t('simulationTypeLbl')"
								:options="simulationTypes"
								name="simulationType"
								class="simulationType cell"
							></ja-dropdown>
							<ja-date-input
								v-model="searchQuerySimStartDate"
								:label="$t('simStartDateLbl')"
								name="simStartDate"
								class="simStartDate cell"
							></ja-date-input>
						</div>
						<div class="grid-row">
							<!--<ja-date-input
								v-model="searchQueryVisitStartDate"
								:label="$t('visitStartDateLbl')"
								name="visitStartDate"
								class="visitStartDate cell"
							></ja-date-input>-->
							<ja-input
								v-model.trim="searchQuerySchool"
								name="school"
								:placeholder="$t('schoolName')"
								:label="$t('schoolName')"
								class="school-name cell"
							></ja-input>
						</div>
					</div>
					<div class="button-container">
						<ja-button
							v-if="validFilterInfo || filterButtonIsDisabled"
							class="small"
							name="applyFilters"
							:value="$t('applyFilters')"
							:disabled="filterButtonIsDisabled"
							@click.native="[toggleFilter(), refetchSimulations()]"
							>{{ $t('applyFilters') }}
						</ja-button>

						<ja-button
							v-if="!validFilterInfo && !filterButtonIsDisabled"
							class="small"
							name="applyFilters"
							:value="$t('applyFilters')"
							:disabled="filterButtonIsDisabled"
							@click.native="[toggleFilter(), resetSearchField()]"
						>
							{{ $t('clearFilters') }}
						</ja-button>
					</div>
					<div v-if="simulations.length" class="container-list-simulations">
						<div class="head-row simulations-row">
							<div
								v-for="(sim, index) in simManagentTableColumns"
								:key="index"
								class="simulation-column"
							>
								<div class="sim-table-title">
									<div class="table-title-text" @click="sortSimulations(sim)">
										<span>{{ `${$t(sim.value)}` }}</span>
									</div>
									<div class="table-title-icon">
										<svgicon
											name="arrows-double"
											class="arrows"
											:original="true"
											@click.native="sortSimulations(sim)"
										></svgicon>
									</div>
								</div>
							</div>
							<div class="simulation-column delete-simulation">
								<svgicon
									:name="ifAnyPlayedSim ? 'pause' : 'play'"
									class="pause"
									:original="true"
									:class="toggleStatusSimulations"
									@click="setAllToPause"
								></svgicon>
							</div>
						</div>
						<div
							v-for="simulation in simulations"
							:key="simulation.id"
							class="simulations-row"
							:class="statusSimulation(simulation)"
							@click="onSimulationClick(simulation, $event.target)"
						>
							<div class="simulation-column" name="simulation-session-name">
								{{ simulation.sessionName }}
							</div>
							<div class="simulation-column" name="simulation-school">
								{{ simulation.school }}
							</div>
							<div class="simulation-column" name="simulation-program-name">
								{{ simulation.programName }}
							</div>
							<div class="simulation-column" name="simulation-type">
								{{ convertToNormalFormat(simulation.simulationType) }}
							</div>

							<div class="simulation-column">
								<div
									v-if="simulation.visitStartDate"
									name="simulation-visit-start-date"
								>
									{{ simulation.visitStartDate | dateFormatNumeric }}
								</div>
							</div>
							<div class="simulation-column">
								<div v-if="simulation.startDate" name="simulation-start-date">
									{{ simulation.startDate | dateFormatNumeric }}
								</div>
							</div>
							<div
								class="status-simulation simulation-column"
								name="status-simulation"
								:class="{
									disabled: !simulation.isActive
								}"
							>
								<svgicon
									:name="statusSimulation(simulation)"
									:class="{
										disabled: !simulation.isActive
									}"
									@click.stop="setStatusSimulation(simulation)"
								></svgicon>
							</div>
							<div
								class="simulation-column more-menu-actions"
								@click.stop="openMenu(simulation.id)"
							>
								<ja-menu-more
									:open="shouldOpen(simulation.id)"
									@close="closeMenu(simulation.id)"
								>
									<ja-button
										name="btn"
										class="small transparent body-text-1"
										:disabled="!simulation.hasCsvData"
										@click.native="exportStudentsEnrollment(simulation.id)"
									>
										{{ $t('exportStudentsEnrollment') }}
									</ja-button>
									<ja-button
										name="btn"
										class="small transparent body-text-1"
										@click.native="viewAsStudent(simulation.id)"
									>
										{{ $t('viewAsStudent') }}
									</ja-button>

									<ja-button
										name="btn"
										class="small transparent body-text-1 danger"
										:disabled="simulation.isActive || !isCloud"
										@click.native="openDeleteSimulationModal(simulation)"
									>
										{{ $t('delete') }}
									</ja-button>
								</ja-menu-more>
							</div>
						</div>
					</div>
					<ja-pagination
						:current="allSimulationsCurrentPage"
						:data-per-page="allSimulationsPerPage"
						:data-count="allSimulationsCount"
						@changePage="setAllSimulationsPage"
					></ja-pagination>

					<ja-delete-simulation-modal
						:show="showSimulationDeletionModal"
						:simulation="selectedSimulation"
						@closeDeleteSimulationModal="onCloseDeleteSimulationModal"
					></ja-delete-simulation-modal>
				</content>
			</ja-dashboard-container>
		</div>
	</div>
</template>

<script>
import '@/components/icons/arrows-double';
import '@/components/icons/play';
import '@/components/icons/pause';

import graphqlClient from '@/helpers/graphqlClient';
import gql from 'graphql-tag';
import DashboardContainer from '../elements/DashboardContainer';
import DeleteSimulationModal from '../modals/DeleteSimulationModal';
import Dropdown from '@/components/ui/form/Dropdown';
import Input from '@/components/ui/form/Input';
import Button from '@/components/ui/Button';
import Pagination from '../elements/Pagination';
import DateInput from '../../ui/form/DateInput';
import AdminFacility from '@/mixins/AdminFacility';
import { generateUUID, downloadCsvFile } from '@/helpers/utils';
import { isCloudEnvironment } from '@/helpers/environment/useEnvConfig';
import MenuMore from './MenuMore';

export default {
	components: {
		jaDashboardContainer: DashboardContainer,
		jaDropdown: Dropdown,
		jaInput: Input,
		jaButton: Button,
		jaDeleteSimulationModal: DeleteSimulationModal,
		jaPagination: Pagination,
		jaDateInput: DateInput,
		jaMenuMore: MenuMore
	},
	mixins: [AdminFacility],

	props: {
		simulationTypes: {
			type: Array,
			default: null
		},
		facilities: {
			type: Array,
			default: null
		}
	},
	data() {
		return {
			simulations: [],
			allSimulations: [],
			simSortingOptionIndex: 0,
			facilityFilteringOptionIndex: 0,
			simulationTypeFilteringOptionIndex: 0,
			showSimulationDeletionModal: false,
			selectedSimulation: null,
			allSimulationsCurrentPage: 1,
			allSimulationsPerPage: 25,
			allSimulationsCount: 0,
			simManagentTableColumns: [
				{ name: this.$t('simulationName'), value: 'sessionName' },
				{ name: this.$t('schoolName'), value: 'school' },
				{ name: this.$t('program'), value: 'programName' },
				{ name: this.$t('simulationType'), value: 'simulationType' },
				{ name: this.$t('onSiteDate'), value: 'visitStartDate' },
				{ name: this.$t('simulationStartDate'), value: 'startDate' }
			],
			validFilterInfo: true,
			school: '',
			requestMade: true,
			searchQueryProgram: '',
			searchQuerySchool: '',
			searchQuerySimStartDate: null,
			searchQueryVisitStartDate: null,
			order: 'asc',
			statusStopAllSimulations: false,
			educatorID: '5',
			toggleMenuMore: []
		};
	},
	computed: {
		isCloud() {
			return isCloudEnvironment;
		},
		filterButtonIsDisabled() {
			return (
				this.searchQuerySchool.length < 3 &&
				!this.simulationType &&
				!this.searchQuerySimStartDate &&
				!this.searchQueryVisitStartDate
			);
		},
		simulationType() {
			if (this.simulationTypes.length) {
				return this.simulationTypes[this.simulationTypeFilteringOptionIndex]
					.value;
			}
			return null;
		},
		ifAnyPlayedSim() {
			return this.allSimulations.some(sim => sim.isPaused === false);
		}
		/* isEducator() {
			return this.userData.roleId == this.educatorID;
		} */
	},
	watch: {
		selectedFacility() {
			this.getSimulations();
		},
		filterButtonIsDisabled() {
			if (this.filterButtonIsDisabled === true)
				return (this.validFilterInfo = true);
		},

		simulations() {
			this.onLoadingStop();
			this.$store.commit('setLoading', false);
		},
		ifAnyPlayedSim() {
			this.statusStopAllSimulations = this.ifAnyPlayedSim;
		}
	},

	mounted() {
		if (this.selectedFacilityId != null) {
			this.getSimulations();
		}
	},

	methods: {
		// TODO: Get infor in Sim Management
		// Check if we need something to be delivered here
		async getSimulations() {
			this.onLoadingStart();
			const filters = [];
			const sortBy = this.simManagentTableColumns[this.simSortingOptionIndex]
				.value;
			if (this.searchQuerySchool) {
				filters.push(`school.Contains("${this.searchQuerySchool}")`);
			}
			if (this.searchQuerySimStartDate) {
				this.searchQuerySimStartDate.setHours(0, 0, 0, 0);
				filters.push(
					`startDate>="${this.searchQuerySimStartDate.toISOString()}"`
				);
			}
			if (this.searchQueryVisitStartDate) {
				this.searchQueryVisitStartDate.setHours(0, 0, 0, 0);
				filters.push(
					`visitStartDate>="${this.searchQueryVisitStartDate.toISOString()}"`
				);
			}
			if (this.simulationType) {
				filters.push(`simulationType=="${this.simulationType}"`);
			}
			filters.push(`facility_ID=${this.selectedFacilityId}`);

			const { data } = await graphqlClient.query({
				query: gql`
					query SimulationsOrder(
						$order: String!
						$where: String!
						$skip: Int!
						$take: Int!
					) {
						simulations: simulations(
							order: $order
							where: $where
							skip: $skip
							take: $take
						) {
							id
							upperSimulationTemplate_ID
							facility
							simulationType
							sessionName
							school
							programName
							visitStartDate
							startDate
							programID
							facility_ID
							bCRMClassNumber
							endDate
							visitEndDate
							reducedLunchPercentage
							percentageOfNmiToSavings
							areaID
							isCompleteLifeStageOptionEnabled
							cmsUpperSimulationTemplate {
								templateName
								startLifeStage_ID
							}
							isPaused
							isReplayOptionEnabled
							studentsCsv
							isCreditCardEnable
							externalId
						}
						allSimulations: simulations(where: $where) {
							id
							isPaused
							simulationType
							programID
							startDate
							endDate
						}
					}
				`,
				fetchPolicy: 'no-cache',
				variables: {
					order: `${sortBy} ${this.order}`,
					where: filters.join('&&'),

					skip: Math.max(
						(this.allSimulationsCurrentPage - 1) * this.allSimulationsPerPage,
						0
					),
					take: this.allSimulationsPerPage
				}
			});
			// in-place remap to assign isActive and hasCsvData
			data.simulations.forEach(sim => {
				sim.isActive = this.simulationIsActive(sim);
				sim.hasCsvData = this.simulationHasCsvData(sim);
			});
			// TODO: refactor this to use more proper way of setting isActive
			// Instead of copy-paste the lines above
			data.allSimulations.forEach(
				sim => (sim.isActive = this.simulationIsActive(sim))
			);

			this.requestMade = false;
			this.allSimulationsCount = data.allSimulations.length;
			this.allSimulations = data.allSimulations;
			this.onLoadingStop();
			this.simulations = data.simulations;
		},
		statusSimulation(simulation) {
			return simulation.isPaused ? 'play' : 'pause';
		},
		async setStatusSimulation(simulation) {
			if (!simulation.isActive) {
				return;
			}

			this.onLoadingStart();

			const simulationInfo = {
				id: simulation.id,
				isPaused: !simulation.isPaused,
				simulationType: simulation.simulationType,
				programID: simulation.programID
			};

			await this.$apollo
				.mutate({
					mutation: gql`
						mutation($update: SimulationInputObjectGraphType!) {
							updateIgnoreNullValuesSimulation(update: $update) {
								id
							}
						}
					`,
					variables: {
						update: simulationInfo
					}
				})
				.then(response => {
					if (response.data) {
						this.refetchSimulations();
					}
				});
		},

		toggleStatusSimulations() {
			this.statusStopAllSimulations = !this.statusStopAllSimulations;
		},
		updateFacilitySelection() {
			this.allSimulationsCurrentPage = 1;
			this.refetchSimulations();
		},

		async setAllToPause() {
			this.onLoadingStart();

			this.toggleStatusSimulations();

			const list = [];
			for (let key in this.allSimulations) {
				let simulation = this.allSimulations[key];
				if (!simulation.isActive) {
					continue;
				}
				let simulationObj = {};
				simulationObj.id = simulation.id;
				simulationObj.isPaused = this.statusStopAllSimulations ? false : true;
				simulationObj.simulationType = simulation.simulationType;
				simulationObj.programID = simulation.programID;

				list.push(simulationObj);
			}

			const response = await this.$apollo.mutate({
				mutation: gql`
					mutation($list: [SimulationInputObjectGraphType]) {
						addOrUpdateIgnoreNullValuesManySimulation(list: $list) {
							id
						}
					}
				`,
				variables: {
					list: list
				}
			});
			if (response.data) {
				this.refetchSimulations();
				this.$store.commit('setLoading', false);
			}
		},
		onSimulationClick(simulation, target) {
			if (!target.hasAttribute('data-preview')) {
				this.$emit('openSimulation', simulation);
			}
		},
		refetchSimulations() {
			this.requestMade = true;
			this.onLoadingStart();
			this.getSimulations();
		},
		refetchSimulationsInAscOrder() {
			this.order = 'asc';
			this.refetchSimulations();
		},
		openDeleteSimulationModal(simulation) {
			if (!simulation.isActive) {
				this.showSimulationDeletionModal = true;
				this.selectedSimulation = simulation;
			}
		},
		onCloseDeleteSimulationModal() {
			this.showSimulationDeletionModal = false;
			this.refetchSimulations();
		},
		setAllSimulationsPage(page) {
			this.allSimulationsCurrentPage = page;
			this.refetchSimulations();
		},
		toggleFilter() {
			this.validFilterInfo = !this.validFilterInfo;
		},
		resetSearchField() {
			this.school = '';
			this.programName = '';
			this.searchQueryProgram = '';
			this.searchQuerySchool = '';
			this.searchQueryVisitStartDate = null;
			this.searchQuerySimStartDate = null;
			this.simulationTypeFilteringOptionIndex = 0;
			this.validFilterInfo = true;
			this.refetchSimulations();
		},
		sortSimulations(option) {
			this.simSortingOptionIndex = this.simManagentTableColumns.indexOf(option);

			if (this.order === 'asc') {
				this.order = 'desc';
			} else {
				this.order = 'asc';
			}
			this.refetchSimulations();
		},
		simulationIsActive(simulation) {
			var startSimDate = new Date(simulation.startDate);
			var endSimDate = new Date(simulation.endDate);

			var today = new Date();
			var convertTodayDate = new Date(
				Date.UTC(
					today.getUTCFullYear(),
					today.getUTCMonth(),
					today.getUTCDate(),
					today.getUTCHours(),
					today.getUTCMinutes(),
					today.getUTCSeconds(),
					today.getUTCMilliseconds()
				)
			);

			if (
				startSimDate.getTime() <= convertTodayDate.getTime() &&
				endSimDate.getTime() > convertTodayDate.getTime()
			) {
				return true;
			}
			return false;
		},
		simulationHasCsvData(simulation) {
			return simulation.studentsCsv ? true : false;
		},
		onLoadingStart() {
			this.$emit('loadingStartForAdmin');
		},
		onLoadingStop() {
			this.$emit('loadingStopForAdmin');
		},
		convertToNormalFormat(typeName) {
			var result = this.simulationTypes.find(type => {
				if (type.value === typeName) {
					return type.name;
				}
			});

			return result.name;
		},
		exportStudentsEnrollment(simId) {
			const simulation = this.getSimulationById(simId);
			if (simId && simulation.studentsCsv) {
				const fileName = `Student simulation-${simId}`;
				return downloadCsvFile(simulation.studentsCsv, fileName);
			}
		},
		viewAsStudent(simId) {
			const routeData = this.$router.resolve({
				name: 'studentview',
				query: {
					sid: simId,
					demoSuid: `${generateUUID()}@demo.com`
				}
			});
			window.open(routeData.href, '_blank');
		},
		closeMenu(id) {
			const index = this.toggleMenuMore.indexOf(id);
			this.toggleMenuMore.splice(index, 1);
		},
		openMenu(id) {
			this.toggleMenuMore = [];
			this.toggleMenuMore.push(id);
		},
		shouldOpen(id) {
			return this.toggleMenuMore.indexOf(id) !== -1;
		},
		getSimulationById(simId) {
			if (simId && this.simulations.length) {
				return this.simulations.find(sim => sim.id === simId);
			}
			return null;
		}
	}
};
</script>
<style lang="scss" scoped>
.page-content {
	flex-grow: 1;

	.head-content {
		margin: auto;
		max-width: 1000px;
		margin-top: 32px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		justify-content: space-between;

		.search-wrapper {
			width: 300px;
			margin-right: 16px;
		}

		.add-new-wrapper {
			flex-grow: 1;
			text-align: right;
		}
	}
}

.content-wrapper {
	position: inherit;

	::v-deep.dashboard-wrapper {
		border-radius: 0px;
		overflow: inherit;
	}

	.grid {
		padding: 16px 16px 16px 16px;
		display: flex;
		flex-direction: column;
		.grid-row {
			display: flex;
			align-items: flex-start;

			&:not(:last-child) {
				margin-bottom: 16px;
			}

			> * {
				flex: 0 0 calc(50% - 8px);

				&:first-child {
					margin-right: 16px;
				}
			}
			&.align-bottom {
				align-items: flex-end;
			}
		}
	}

	.row {
		display: flex;
		justify-content: space-between;
		padding: 8px 16px;

		.facilities-dropdown {
			width: 100%;
		}

		.sort-header {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.school-name {
				@media (min-width: $breakpoint-mid) {
					min-width: 300px;
				}

				&:nth-child(1) {
					border-bottom: 1px solid $container-border;
					width: 100%;
				}
			}

			&:nth-child(3) {
				display: flex;
				width: 100%;
				justify-content: space-between;
				align-items: center;

				div {
					width: inherit;
					margin-right: 10px;
				}
			}

			h5 {
				text-transform: initial;
				letter-spacing: initial;
				font-family: 'RobotoMedium';
				font-size: 16px;
				color: $font-header;
				margin-right: 8px;
				min-width: 60px;

				@media (min-width: $breakpoint-mid) {
					font-size: 20px;
					min-width: 75px;
				}
			}

			::v-deep.dropdown-component {
				display: flex;
				align-items: center;
				width: 100%;

				label {
					color: red;
					margin: 0;

					h5 {
						text-transform: initial;
						letter-spacing: initial;
						font-family: 'RobotoMedium';
						font-size: 16px;
						color: $font-header;
						margin-right: 8px;
						min-width: 60px;

						@media (min-width: $breakpoint-mid) {
							font-size: 20px;
							min-width: 75px;
						}
					}
				}
				.dropdown-wrapper {
					width: 100%;

					::v-deep .dropdown {
						width: 200px;

						&:nth-child(1) {
							width: auto;
						}
					}
				}
			}
		}
	}
	.button-container {
		display: flex;
		justify-content: center;
		margin-bottom: 15px;
	}

	.container-list-simulations {
		display: table;
		width: 100%;
		border-collapse: collapse;
		.simulations-row {
			border-top: 1px solid $table-border;
			display: table-row;

			&:hover {
				cursor: pointer;
			}

			&.play {
				background-color: $selected-student-bgcolor;
				color: $table-content-font;
				.simulation-column {
					opacity: 0.4;
				}
			}
			&:last-child {
				border-bottom: 1px solid $table-border;
			}

			.simulation-column {
				display: table-cell;
				text-transform: initial;
				// border-bottom: 1px solid $table-border;
				padding: 16px 16px 16px 0;
				min-width: 90px;
				max-width: 100px;
				word-break: break-word;

				&:first-child {
					padding-left: 16px;
					max-width: 120px;
				}

				&:not(:first-child) {
					min-width: 70px;
				}

				&.more-menu-actions {
					min-width: initial;
				}

				.sim-table-title {
					font-family: 'RobotoMedium';
					color: $table-head-font;
					font-size: 14px;
					letter-spacing: 0.25px;
					text-transform: uppercase;
					max-width: 90px;
					display: flex;
					@media (min-width: $breakpoint-mid) {
						font-size: 16px;
						letter-spacing: 0.5px;
					}

					.table-title-text {
						width: min-content;
					}
					.table-title-icon {
						height: 100%;
						margin-top: 10px;
						padding-left: 5px;

						@media (min-width: $breakpoint-mid) {
							font-size: 16px;
							margin-top: 15px;
						}
					}
				}
				.svg-icon {
					width: auto;
				}
				@media (min-width: $breakpoint-mid) {
					font-size: 18px;
				}

				.arrows {
					float: right;
				}
			}

			.set-all-pause {
				outline: 0;
				border: 0;
				background-color: transparent;
				margin-left: -10px;

				.body-text-1 {
					font-family: 'RobotoMedium';
					color: $primary-state;
					display: inline-block;
					vertical-align: middle;
				}

				.svg-icon {
					height: 24px;
					width: 24px;
					margin-right: 6px;
					fill: $primary-state;
					display: inline-block;
					vertical-align: middle;
				}
				@media (any-hover: hover) {
					&:hover {
						cursor: pointer;

						.body-text-1 {
							color: $hover-state;
						}

						.svg-icon {
							fill: $hover-state;
						}
					}
				}
			}
		}
		.head-row {
			align-items: center;

			.simulation-column {
				// border-top: 1px solid $container-border;
				word-break: inherit;
			}
		}
		.simulation-column-data {
			display: flex;
			align-items: center;
		}

		.status-simulation {
			min-width: auto !important;
			padding-right: 0px !important;
			opacity: 1 !important;

			.svg-icon {
				height: 24px;
				width: 24px;
				color: $icon-available;
				cursor: pointer;
			}
			&.disabled {
				cursor: not-allowed;

				.disabled {
					color: $icon-disabled;
					fill: $icon-disabled;
					cursor: not-allowed;
				}
			}
		}
		.delete-simulation,
		.more-menu-actions {
			min-width: auto !important;
			padding-right: 0px !important;
			opacity: 1 !important;

			.svg-icon {
				height: 24px;
				width: 24px;
				margin-right: 16px;
				color: $deleteStudentField;
				cursor: pointer;
			}
			&.disabled {
				cursor: not-allowed;

				.disabled {
					color: $icon-disabled;
					fill: $icon-disabled;
					cursor: not-allowed;
				}
			}
		}
	}
}
</style>
